











































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { debounce } from 'lodash';
import moment from 'moment';

import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import {
  emitFormChangeEvent,
  FormFieldDefMap,
  FormState as BaseFormState,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import CampoContrasena from '@/reusable/Form/CampoContrasena.vue';
import { fetchProveedoresGps } from '@/reusable/proveedorGps/fetchProveedoresGps';
import { Snotify } from '@/snotify/Snotify';
import { LoadingService } from '@/services/loadingService';
import {
  ClienteProveedorGps,
  fetchClientesProveedorGps,
} from '@/reusable/proveedorGps/fetchClientesProveedorGps';
import { EstadoEntidad } from '@/config/enums';
import { EstadosService } from '@/services/estadosService';
import CodeView from '@/reusable/CodeView/CodeView.vue';

import { ContratoProveedorBackend } from '@/interfaces/ContratoProveedor';
import ValidarRespuestaModal from '@/pantallas/ContratoProveedor/ValidarRespuestaModal.vue';

@Component({
  components: {
    CampoContrasena,
    DatePicker,
    FormFieldsContainer,
    CodeView,
    ValidarRespuestaModal,
  },
})
export default class MapeoRespuesta extends Vue {
  @Prop({ default: false }) modoVer: boolean;
  @Prop() contratoRespuesta: string;

  valorScript: string = '';
  muestraModalValidar: boolean = false;

  mounted() {
    this.handleContratoProveedorChange();
  }

  @Watch('contratoRespuesta', { deep: true })
  handleContratoProveedorChange() {
    if (this.contratoRespuesta) {
      this.valorScript = this.contratoRespuesta;
    }
  }

  handleMapeoRespuestaBlur(valor: string) {
    this.valorScript = valor;
    this.$emit('blur', valor);
  }

  handleValidarRespuestaClick() {
    this.muestraModalValidar = true;
  }

  handleCierreModal() {
    this.muestraModalValidar = false;
  }
}
